// extracted by mini-css-extract-plugin
export default {"privacy_policy":"privacePolicy_privacy_policy__-6sz8","title":"privacePolicy_title__r9EWG"};